/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React from 'react';
import styles from '../../styles/profile/HeroSection.module.css';
import Tile01 from './Tile01';
import i1 from '../../assets/profile/img1.png';
import i2 from '../../assets/profile/img2.png';
import i3 from '../../assets/profile/img3.png';
import i4 from '../../assets/profile/img4.png';
import ei from '../../assets/profile/profile.svg';
import i6 from '../../assets/profile/img7.png';
import i7 from '../../assets/profile/Learners.png';
import i8 from '../../assets/profile/mingcute_time-line.png';
import i9 from '../../assets/profile/Star.png';
import i10 from '../../assets/profile/Schedule.png';
import i11 from '../../assets/profile/ad1.png';
import i12 from '../../assets/profile/ad2.png';
import i13 from '../../assets/profile/ad3.png';

// type UserRole = 'coachee' | 'coach';
type UserRole = 'coach' | 'coachee' | 'admin';

interface HeroSectionProps {
	isEditing: boolean;
	profileImage: string;
	fullName: string;
	role: UserRole;
	bio: string;
	badges: number;
	certificates: number;
	courses?: number; // 👈 optional
	totalSessions: number;

	learnersCoached?: number;
	coachingHours?: number;
	avgRating?: number;
	programsDelivered?: number;
	activeCoaches?: number;
	activeLearners?: number;
	upcomingSessions?: number;
	activePrograms?: number;
	onBioChange?: (value: string) => void;
	onImageUploadClick?: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({
	isEditing,

	profileImage,
	fullName,
	role,
	bio,
	badges,
	certificates,
	courses,
	totalSessions,
	learnersCoached,
	coachingHours,
	avgRating,
	programsDelivered,
	activeCoaches,
	activeLearners,
	upcomingSessions,
	activePrograms,
	onBioChange,
	onImageUploadClick,
}) => {
	const displayRole =
		role === 'coachee' ? 'Learner' : role === 'coach' ? 'Coach' : 'Admin';
	return (
		<>
			<div className={styles.heroSection}>
				{/* HEADER */}

				{/* PROFILE INFO */}

				<div className={styles.profileImageWrapper}>
					<img
						src={profileImage} // 👈 always show uploaded image or fallback
						alt="Profile"
						className={styles.profileImage}
					/>

					{isEditing && (
						<button
							type="button"
							className={styles.editIconOverlay}
							onClick={onImageUploadClick}
						>
							<img
								src={i6}
								alt="Edit Icon"
								className={styles.editIconOverlayIcon}
							/>
						</button>
					)}
				</div>

				<div className={styles.profileContent}>
					{isEditing ? (
						<>
							<div className={styles.nameRow}>
								<div className={styles.fullName}>
									{fullName}
								</div>
								<span
									className={`${styles.roleBadge} ${
										role === 'coach'
											? styles.coach
											: role === 'admin'
												? styles.admin
												: styles.coachee
									}`}
								>
									{displayRole}
								</span>
							</div>
							<div className={styles.biohead}>
								<div className={styles.bio}>Bio</div>

								<textarea
									className={styles.textArea}
									value={bio}
									onChange={e =>
										onBioChange?.(e.target.value)
									}
								/>
							</div>
						</>
					) : (
						<>
							<div className={styles.nameRow}>
								{/* <h3>{fullName}</h3> */}
								<div className={styles.fullName}>
									{fullName}
								</div>
								{/* <span className={styles.roleBadge}>{role}</span> */}
								{/* <span className={styles.roleBadge}>{displayRole}</span> */}
								<span
									className={`${styles.roleBadge} ${
										role === 'coach'
											? styles.coach
											: role === 'admin'
												? styles.admin
												: styles.coachee
									}`}
								>
									{displayRole}
								</span>
							</div>
							<div className={styles.biohead}>
								<div className={styles.bio}>Bio</div>
								<div className={styles.bioContent}>{bio}</div>
							</div>
						</>
					)}

					{/* LEARNING ACHIEVEMENTS */}

					<div className={styles.learningAchievements}>
						{role === 'admin'
							? 'Platform Overview'
							: role === 'coach'
								? 'Coaching Performance'
								: 'Learning Achievements'}
					</div>

					<div className={styles.achievements}>
						{role === 'coachee' && (
							<>
								<Tile01
									iconSrc={i1}
									title="Badges"
									value={badges}
									altText="Badges icon"
								/>

								<Tile01
									iconSrc={i2}
									title="Certificates"
									value={certificates}
									altText="Certificates icon"
								/>

								<Tile01
									iconSrc={i3}
									title="Enrolled Programs"
									value={courses ?? 0}
									altText="Courses icon"
								/>

								<Tile01
									iconSrc={i4}
									title="Upcoming Activities"
									value={totalSessions}
									altText="Sessions icon"
								/>
							</>
						)}
						{role === 'coach' && (
							<>
								<Tile01
									iconSrc={i7}
									title="Learners Coached"
									value={learnersCoached ?? 0}
									altText="Badges icon"
								/>

								<Tile01
									iconSrc={i8}
									title="Coaching Hours"
									value={coachingHours ?? 0}
									altText="Certificates icon"
								/>

								<Tile01
									iconSrc={i9}
									title="Average Rating"
									value={avgRating ?? 0}
									altText="Courses icon"
								/>
								<Tile01
									iconSrc={i10}
									title="Programs Delivered"
									value={programsDelivered ?? 0}
									altText="Courses icon"
								/>
							</>
						)}
						{role === 'admin' && (
							<>
								<Tile01
									iconSrc={i7}
									title="Active Coaches"
									value={activeCoaches ?? 0}
									altText="Active Coaches"
								/>

								<Tile01
									iconSrc={i11}
									title="Active Learners"
									value={activeLearners ?? 0}
									altText="Active Learners"
								/>

								<Tile01
									iconSrc={i12}
									title="Upcoming Sessions"
									value={upcomingSessions ?? 0}
									altText="Upcoming Sessions"
								/>

								<Tile01
									iconSrc={i13}
									title="Active Programs"
									value={activePrograms ?? 0}
									altText="Active Programs"
								/>
							</>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default HeroSection;
